 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import A780312375942_EPUB_CVI_R1 from '@/components/9780312375942_epub_cvi_r1'
 import A780312375942_EPUB_ADC_R1 from '@/components/9780312375942_epub_adc_r1'
 import A780312375942_EPUB_TP_R1 from '@/components/9780312375942_epub_tp_r1'
 import A780312375942_EPUB_COP_R1 from '@/components/9780312375942_epub_cop_r1'
 import A780312375942_EPUB_DED_R1 from '@/components/9780312375942_epub_ded_r1'
 import A780312375942_EPUB_TOC_R1 from '@/components/9780312375942_epub_toc_r1'
 import A780312375942_EPUB_ACK_R1 from '@/components/9780312375942_epub_ack_r1'
 import A780312375942_EPUB_FM_R1 from '@/components/9780312375942_epub_fm_r1'
 import A780312375942_EPUB_ITR_R1 from '@/components/9780312375942_epub_itr_r1'
 import A780312375942_EPUB_C01_R1 from '@/components/9780312375942_epub_c01_r1'
 import A780312375942_EPUB_C02_R1 from '@/components/9780312375942_epub_c02_r1'
 import A780312375942_EPUB_C03_R1 from '@/components/9780312375942_epub_c03_r1'
 import A780312375942_EPUB_C04_R1 from '@/components/9780312375942_epub_c04_r1'
 import A780312375942_EPUB_C05_R1 from '@/components/9780312375942_epub_c05_r1'
 import A780312375942_EPUB_C06_R1 from '@/components/9780312375942_epub_c06_r1'
 import A780312375942_EPUB_C07_R1 from '@/components/9780312375942_epub_c07_r1'
 import A780312375942_EPUB_C08_R1 from '@/components/9780312375942_epub_c08_r1'
 import A780312375942_EPUB_C09_R1 from '@/components/9780312375942_epub_c09_r1'
 import A780312375942_EPUB_C10_R1 from '@/components/9780312375942_epub_c10_r1'
 import A780312375942_EPUB_C11_R1 from '@/components/9780312375942_epub_c11_r1'
 import A780312375942_EPUB_C12_R1 from '@/components/9780312375942_epub_c12_r1'
 import A780312375942_EPUB_C13_R1 from '@/components/9780312375942_epub_c13_r1'
 import A780312375942_EPUB_C14_R1 from '@/components/9780312375942_epub_c14_r1'
 import A780312375942_EPUB_C15_R1 from '@/components/9780312375942_epub_c15_r1'
 import A780312375942_EPUB_C16_R1 from '@/components/9780312375942_epub_c16_r1'
 import A780312375942_EPUB_C17_R1 from '@/components/9780312375942_epub_c17_r1'
 import A780312375942_EPUB_C18_R1 from '@/components/9780312375942_epub_c18_r1'
 import A780312375942_EPUB_C19_R1 from '@/components/9780312375942_epub_c19_r1'
 import A780312375942_EPUB_C20_R1 from '@/components/9780312375942_epub_c20_r1'
 import A780312375942_EPUB_EPL_R1 from '@/components/9780312375942_epub_epl_r1'
 import A780312375942_EPUB_APP_R1 from '@/components/9780312375942_epub_app_r1'
 import A780312375942_EPUB_NTS_R1 from '@/components/9780312375942_epub_nts_r1'
 import A780312375942_EPUB_BIB_R1 from '@/components/9780312375942_epub_bib_r1'
 import A780312375942_EPUB_BM_R1 from '@/components/9780312375942_epub_bm_r1'
 import A780312375942_EPUB_IND_R1 from '@/components/9780312375942_epub_ind_r1'
 import A780312375942_EPUB_ATA_R1 from '@/components/9780312375942_epub_ata_r1'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/9780312375942_epub_cvi_r1",
 			"name" : "9780312375942_epub_cvi_r1",
 			"component" : A780312375942_EPUB_CVI_R1
 		},
 		{
 			"path" : "/9780312375942_epub_adc_r1",
 			"name" : "9780312375942_epub_adc_r1",
 			"component" : A780312375942_EPUB_ADC_R1
 		},
 		{
 			"path" : "/9780312375942_epub_tp_r1",
 			"name" : "9780312375942_epub_tp_r1",
 			"component" : A780312375942_EPUB_TP_R1
 		},
 		{
 			"path" : "/9780312375942_epub_cop_r1",
 			"name" : "9780312375942_epub_cop_r1",
 			"component" : A780312375942_EPUB_COP_R1
 		},
 		{
 			"path" : "/9780312375942_epub_ded_r1",
 			"name" : "9780312375942_epub_ded_r1",
 			"component" : A780312375942_EPUB_DED_R1
 		},
 		{
 			"path" : "/9780312375942_epub_toc_r1",
 			"name" : "9780312375942_epub_toc_r1",
 			"component" : A780312375942_EPUB_TOC_R1
 		},
 		{
 			"path" : "/9780312375942_epub_ack_r1",
 			"name" : "9780312375942_epub_ack_r1",
 			"component" : A780312375942_EPUB_ACK_R1
 		},
 		{
 			"path" : "/9780312375942_epub_fm_r1",
 			"name" : "9780312375942_epub_fm_r1",
 			"component" : A780312375942_EPUB_FM_R1
 		},
 		{
 			"path" : "/9780312375942_epub_itr_r1",
 			"name" : "9780312375942_epub_itr_r1",
 			"component" : A780312375942_EPUB_ITR_R1
 		},
 		{
 			"path" : "/9780312375942_epub_c01_r1",
 			"name" : "9780312375942_epub_c01_r1",
 			"component" : A780312375942_EPUB_C01_R1
 		},
 		{
 			"path" : "/9780312375942_epub_c02_r1",
 			"name" : "9780312375942_epub_c02_r1",
 			"component" : A780312375942_EPUB_C02_R1
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js